
export interface History {
  history_Id: number;
  user: string;
  problem_RefId: number;
  object_RefId: number;
  changeType: string;
  timestamp: Date;
  original: string;
  modified: string;
  description: string;
}

export enum SortBy {
  Id,
  User,
  Type,
  Timestamp,
  Original,
  Modified,
  Description
}

export enum SortDirection {
  Asc,
  Desc
}

export function sortHistory(
  records: History[],
  sortBy: SortBy = SortBy.Id,
  sortDirection: SortDirection = SortDirection.Asc,
  changeTypeMap: Map<string, string> = null): History[] {

  const sortedArray = [...records];

  switch (sortBy) {
    case SortBy.User:
      sortedArray.sort((lhs, rhs) => lhs.user.localeCompare(rhs.user));
      break;
    case SortBy.Type:
      sortedArray.sort((lhs, rhs) => changeType(lhs, changeTypeMap).localeCompare(changeType(rhs, changeTypeMap)));
      break;
    case SortBy.Timestamp:
      // This is unstable and results in the order of the activity and it's related problem history row to switch position between sorts
      // sortedArray.sort((lhs, rhs) => (new Date(lhs.timestamp)).getTime() - (new Date(rhs.timestamp)).getTime());

      // Although timestamp is typed as Date, in the browser's datastructure typeof(lhs.timestamp) is a string
      // like "2020-01-28T11:15:17.6910659-08:00"
      // however when running unit tests, node enforce the Date type on the timestamp property
      sortedArray.sort((lhs, rhs) => {
        if (typeof (lhs.timestamp) === 'string') {
          return (lhs.timestamp as any as string).localeCompare(rhs.timestamp as any as string);
        } else {
          return lhs.timestamp.getTime() - rhs.timestamp.getTime();
        }
      });
      break;
    case SortBy.Original:
      sortedArray.sort((lhs, rhs) => lhs.original.localeCompare(rhs.original));
      break;
    case SortBy.Modified:
      sortedArray.sort((lhs, rhs) => lhs.modified.localeCompare(rhs.modified));
      break;
    case SortBy.Description:
      sortedArray.sort((lhs, rhs) => lhs.description.localeCompare(rhs.description));
      break;
    case SortBy.Id:
    default:
      sortedArray.sort((lhs, rhs) => lhs.history_Id - rhs.history_Id);
      break;
  }

  if (SortDirection.Desc === sortDirection) {
    sortedArray.reverse();
  }

  return sortedArray;
}

export function changeType(
  record: History,
  changeTypeMap: Map<string, string> = null): string {
    return changeTypeMap.get(record.changeType) || record.changeType;
}
